module.exports = __webpack_public_path__ + "img/plan.63c8319.PNG";